import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Instagram, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { Eyebrow, Reveal } from "./Brand";
import { GALLERY, INSTAGRAM, INSTAGRAM_URL } from "../../lib/data";

const Tile = ({ item, i, onOpen }) => (
  <motion.button data-testid={`gallery-item-${item.id}`} onClick={() => onOpen(item)}
    initial={{ opacity: 0, scale: 0.94 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
    className={`group relative overflow-hidden rounded-[22px] border border-white/10 bg-[#111219] text-left aspect-[3/4] w-full ${i % 2 ? "md:mt-16" : ""}`}>
    <img src={item.src} alt={item.category} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(255,210,0,0.25),transparent_55%)] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
    {item.type === "video" ? (
      <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-[#FFD200] text-[#08080C] grid place-items-center transition-transform duration-500 group-hover:scale-110">
        <Play className="w-6 h-6 ml-1" fill="currentColor" />
      </span>
    ) : (
      <Maximize2 className="absolute top-4 right-4 w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
    )}
    <span className="absolute bottom-3 left-3 md:bottom-4 md:left-4 max-w-[calc(100%-1.5rem)] font-mono text-[10px] md:text-[11px] uppercase tracking-[0.08em] md:tracking-[0.2em] leading-tight text-white bg-black/55 backdrop-blur px-2.5 py-1 md:px-3 md:py-1.5 rounded-full">
      {item.type === "video" ? "Vídeo · " : ""}{item.category}
    </span>
  </motion.button>
);

export const Gallery = () => {
  const [open, setOpen] = useState(null);
  return (
    <section id="galeria" data-testid="gallery-section" className="relative py-28 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div>
            <Eyebrow>Fotos & vídeos</Eyebrow>
            <h2 className="mt-6 font-display font-black uppercase text-white text-4xl md:text-6xl leading-[0.95]">Festa de<br /><span className="text-gold-grad">verdade.</span></h2>
          </div>
          <div className="max-w-md">
            <p className="text-zinc-300 text-base md:text-lg">Momentos dos eventos que já animamos. Acompanhe os mais recentes no nosso Instagram.</p>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 items-start">
          {GALLERY.map((g, i) => <Tile key={g.id} item={g} i={i} onOpen={setOpen} />)}
        </div>
        <Reveal className="mt-10 flex justify-center">
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="gallery-instagram-link"
            className="inline-flex items-center gap-3 rounded-full border border-white/15 px-6 py-3 text-white hover:border-[#FFD200] hover:text-[#FFD200] transition-colors">
            <Instagram className="w-5 h-5" /> Ver mais em @{INSTAGRAM}
          </a>
        </Reveal>
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent data-testid="gallery-lightbox" className="max-w-4xl bg-[#08080C] border-white/10 p-2 sm:p-3">
          <DialogTitle className="sr-only">{open?.category}</DialogTitle>
          {open?.type === "video" && open?.video ? (
            <video src={open.video} controls autoPlay className="w-full max-h-[78vh] rounded-xl" />
          ) : (
            <div className="relative">
              <img src={open?.src} alt={open?.category} className="w-full max-h-[78vh] object-contain rounded-xl" />
              {open?.type === "video" && (
                <p className="absolute inset-x-0 bottom-0 m-3 rounded-xl bg-black/70 backdrop-blur p-4 text-sm text-zinc-200">[Vídeo do evento em breve — envie o arquivo ou link para publicarmos aqui]</p>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
